import React from "react";
import FormikInput from "../../../../Components/Formik/FormikInput";
import FormikSelect from "../../../../Components/Formik/FormikSelect";
import { useLanguage } from "../../../../Components/LangTranslation/LanguageContext";
import { COMPANY_DOMAIN } from "../../../../utilities/constants";

function ShopInformationStep({ themeOptions }) {
  const { language, translations } = useLanguage();
  const t = translations[language];
  return (
    <>
      <div className="my-3 col-12">
        <FormikSelect
          name="theme"
          placeholder={t["Pick a theme"]}
          options={themeOptions}
        />
      </div>
      <div className="my-3 col-md-6 col-12">
        <FormikInput name="website_name" placeholder={t["Website Name"]} />
      </div>

      <div className="my-3 col-md-6 col-12">
        <FormikInput name="domain" disabled={true} placeholder={t["Domain"]} />
      </div>
    </>
  );
}

export default ShopInformationStep;
